import React, { useState, useEffect } from "react";
import { Flex, Text, Spinner, Heading } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { primary } from "../../../../utils/colors";
import { getTreatmentPlanStatistics } from "../../../../actions/statisticActions";
import useCountUp from "../../../../hooks/useCountUp";
import useRoleCheck from "../../../../hooks/useRoleCheck";
import TreatmentPlanStatusTotalItem from "./TreatmentPlanStatusTotalItem";
import useThemeColors from "../../../../hooks/useThemeColors";
import TreatmentPlansPieChart from "./TreatmentPlansPieChart";
import { useParams } from "react-router-dom";

const DashboardTreatmentPlansNew = ({ currency }) => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { whiteMode, textPrimaryMode } = useThemeColors();

  // ROLES
  const isDoctor = useRoleCheck("employee_doctor");

  // STATE
  const [hoveredStatus] = useState(null);

  // DROPDOWN

  // REDUX

  const statisticTreatmentPlan = useSelector(
    (state) => state.statisticTreatmentPlan
  );
  const { loading, error, statisticTreatmentPlans } = statisticTreatmentPlan;

  const statisticTreatmentPlanEmployee = useSelector(
    (state) => state.statisticTreatmentPlanEmployee
  );
  const {
    // loading: loadingEmployee,
    // error: errorEmployee,
    statisticTreatmentPlansEmployee,
  } = statisticTreatmentPlanEmployee;

  useEffect(() => {
    dispatch(getTreatmentPlanStatistics(slug));
  }, [dispatch, slug]);

  // Determine which data set to use based on role
  const dataToUse = isDoctor
    ? statisticTreatmentPlansEmployee
    : statisticTreatmentPlans;
  // const isLoading = isDoctor ? loadingEmployee : loading;

  const treatmentPlans = dataToUse?.treatmentPlans || {};

  // Animated counts for each status

  const animatedPlanningCount = useCountUp(
    treatmentPlans?.planning?.count || 0
  );
  const animatedApprovedCount = useCountUp(
    treatmentPlans?.approved?.count || 0?.overallTotalPrice
  );
  const animatedOngoingCount = useCountUp(treatmentPlans?.ongoing?.count || 0);
  const animatedCompletedCount = useCountUp(
    treatmentPlans?.completed?.count || 0
  );
  const animatedCancelledCount = useCountUp(
    treatmentPlans?.cancelled?.count || 0
  );

  // LOGS
  // console.log("treatmentPlans:", treatmentPlans);
  // console.log("statisticTreatmentPlans:", statisticTreatmentPlans);

  if (loading)
    return (
      <Flex
        w="100%"
        bg={whiteMode}
        p="1rem 1.5rem"
        borderRadius="1rem"
        h="567px"
        minH="567px"
        maxH="567px"
        align="center"
        justify="center"
      >
        <Spinner size="lg" color={primary} />
      </Flex>
    );

  if (error) return <Text>Error: {error}</Text>;

  // console.log("treatmentPlans:", treatmentPlans);

  return (
    <>
      <Flex
        w="100%"
        direction="column"
        // as={motion.div}
        // initial={{ opacity: 0 }}
        // animate={{ opacity: 1, transition: { duration: 0.2 } }}
      >
        <Flex
          w="100%"
          bg={whiteMode}
          borderRadius="1rem"
          p="1rem 1.5rem"
          direction="column"
        >
          <Flex w="100%" align="center" justify="space-between" minH="2rem">
            <Flex align="center">
              <Heading
                fontSize="1.125rem"
                fontWeight="600"
                color={textPrimaryMode}
              >
                {t("dashboard.treatmentPlans")}
              </Heading>
            </Flex>

            <Flex align="center" justify="flex-end" gap="0.5rem">
              {/* <Button
                size="sm"
                fontSize="0.8rem"
                bg={backgroundLightMode}
                color={textSecondary}
                borderRadius="1rem"
                isDisabled
              >
                All status
              </Button> */}
            </Flex>
          </Flex>

          <Flex w="100%" position="relative" align="center" justify="center">
            <TreatmentPlansPieChart
              width={252}
              height={252}
              treatmentPlans={treatmentPlans}
              hoveredStatus={hoveredStatus}
              currency={currency}
            />
          </Flex>

          {!loading ? (
            <Flex
              w="100%"
              direction="column"
              gap={["0rem", "0rem"]}
              m="1rem 0 0"
            >
              <TreatmentPlanStatusTotalItem
                loading={loading}
                status="planning"
                count={animatedPlanningCount}
                totalPrice={treatmentPlans?.planning?.totalPrice || 0}
                totalCompletedServicesPrice={
                  treatmentPlans?.planning?.completedServicesTotalPrice || 0
                }
                isServices={isDoctor}
                currency={currency}
              />

              <TreatmentPlanStatusTotalItem
                loading={loading}
                status="approved"
                count={animatedApprovedCount}
                totalPrice={treatmentPlans?.approved?.totalPrice || 0}
                totalCompletedServicesPrice={
                  treatmentPlans?.approved?.completedServicesTotalPrice || 0
                }
                isServices={isDoctor}
                currency={currency}
              />

              <TreatmentPlanStatusTotalItem
                loading={loading}
                status="ongoing"
                count={animatedOngoingCount}
                totalPrice={treatmentPlans?.ongoing?.totalPrice || 0}
                totalCompletedServicesPrice={
                  treatmentPlans?.ongoing?.completedServicesTotalPrice || 0
                }
                isServices={isDoctor}
                currency={currency}
              />

              <TreatmentPlanStatusTotalItem
                loading={loading}
                status="completed"
                count={animatedCompletedCount}
                totalPrice={treatmentPlans?.completed?.totalPrice || 0}
                totalCompletedServicesPrice={
                  treatmentPlans?.completed?.completedServicesTotalPrice || 0
                }
                isServices={isDoctor}
                currency={currency}
              />

              <TreatmentPlanStatusTotalItem
                status="cancelled"
                loading={loading}
                count={animatedCancelledCount}
                totalPrice={treatmentPlans?.cancelled?.totalPrice || 0}
                totalCompletedServicesPrice={
                  treatmentPlans?.cancelled?.completedServicesTotalPrice || 0
                }
                currency={currency}
              />
            </Flex>
          ) : (
            <Flex>
              <Spinner size="md" color={primary} />
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default DashboardTreatmentPlansNew;
